import React, { useContext, useEffect, useState, useReducer } from "react";
import { Navigate, useParams } from 'react-router-dom'
import { db } from "../../../firebase";
import { CurrentEventDataContext } from "../CurrentEventDataContext";

import { firebaseAuth } from '../../../providers/AuthProvider';
import '../../../assets/css/reports.css';
import firebase from "firebase/compat/app";
import { GetDeviceId } from "../../../Constants";
import moment from "moment";
const Sessions = () => {
  const reducer = (state, payload) => ({ ...state, ...payload });
  const [addSessionDate, setAddSessionDate] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [eventReportData, setEventReportData] = useState(null);
  const [regData, setRegData] = useState(null);
  const { user } = useContext(firebaseAuth);
  const { id } = useParams();
  const [data, setData] = useReducer(reducer, {
    registrations: [],
    isFetching: true,
    message: null,
  });
  const { setCurrentEventData } = useContext(CurrentEventDataContext);
  const formatTime = (t) => {
    if (t) {
      let tm = t.split(":");
      let h = +tm[0];
      let m = tm[1];
      let ampm = "AM";

      if (h >= 12) {
        ampm = "PM";
      }
      if (h > 12) {
        h -= 12;
      }
      return h + ":" + m + " " + ampm;
    } else {
      return "";
    }
  }
  const getCount = (passcode, status, isConfirmed) => {
    console.log(passcode)
    if (passcode) {
      if (regData && status !== "Available" && status !== "Total") {
        let count = regData.filter(o => o.passcode.toUpperCase() === passcode.toUpperCase() && o.status === status).length;
        if (isConfirmed) {
          let countConfirmed = regData.filter(o => o.passcode.toUpperCase() === passcode.toUpperCase() && (o.status === status && o.isConfirmed)).length;
          return count + (countConfirmed > 0 ? " (" + countConfirmed + ")" : "");
        } else {
          return count;
        }

      }
      if (regData && status === "Available") {
        let count = eventData?.sessions?.filter(o => o.passcode.toUpperCase() === passcode.toUpperCase()).length;
        let count2 = regData.filter(o => o.passcode.toUpperCase() === passcode.toUpperCase() && (o.status === "Pending" || o.status === "Registered" || o.status === "Checked-In" || o.status === "Completed")).length;
        return count - count2;
      }
      if (regData && status === "Total") {
        let count = eventData?.sessions?.filter(o => o.passcode.toUpperCase() === passcode.toUpperCase()).length;
        return count;
      }
    } else {
      console.log("no passcode");
      if (regData && status !== "Available" && status !== "Total") {
        let count = regData.filter(o => o.status === status).length;
        if (isConfirmed) {
          let countConfirmed = regData.filter(o => (o.status === status && o.isConfirmed)).length;
          return count + (countConfirmed > 0 ? " (" + countConfirmed + ")" : "");
        } else {
          return count;
        }

      }
      if (regData && status === "Available") {
        let count = eventData?.sessions?.length;
        let count2 = regData.filter(o => o.status === "Pending" || o.status === "Registered" || o.status === "Checked-In" || o.status === "Completed").length;
        return count - count2;
      }
      if (regData && status === "Total") {
        let count = eventData?.sessions?.length;
        return count;
      }
    }
    return 0;
  }
  const isActiveSessionRegistration = (reg) =>
    reg.status === "Pending" ||
    reg.status === "Registered" ||
    reg.status === "Checked-In" ||
    reg.status === "Completed";
  const isSessionRegistered = (sessionId, registrations = regData) =>
    sessionId !== -1 &&
    registrations?.some((reg) => reg.sessionId == sessionId && isActiveSessionRegistration(reg));
  const leadMatchesEvent = (lead, event) => !!lead.eventId && lead.eventId === event?.id;
  const addLeadIfForEvent = (doc, event, items) => {
    let tmpItem = doc.data();
    tmpItem.id = doc.id;
    if (!leadMatchesEvent(tmpItem, event)) return;
    if (tmpItem.createdAt && !tmpItem.createdDate)
      try {
        if (tmpItem.createdAt.seconds) {
          // tmpItem.createdAt = tmpItem.createdAt.seconds * 1000 + tmpItem.createdAt.nanoseconds / 1000000;
          tmpItem.createdDate = moment((tmpItem.createdAt.seconds * 1000 + tmpItem.createdAt.nanoseconds / 1000000)).format(
            "MM/DD/YYYY h:mm A"
          );
        } else {
          // alert('ehllo2');
          tmpItem.createdDate = moment(tmpItem.createdAt).format(
            "MM/DD/YYYY h:mm A"
          );
        }
      } catch {
      }

    items.push(tmpItem);
  };
  const loadSessionReport = async (tmpData) => {
    // let tmpEventData = eventData;
    let tmpEventData = tmpData ? tmpData : JSON.parse(sessionStorage.getItem('eventData'));
    if (!tmpEventData || tmpEventData.id !== id) {
      tmpEventData = (await db.collection("events").doc(id).get()).data();

    }
    setEventData(tmpEventData);
    setCurrentEventData(tmpEventData);
    // sessionStorage.setItem('eventData', JSON.stringify(tmpEventData));
    if (tmpEventData.allowCapacity && tmpEventData.capacityType === "session") {

      let regDataLookup = await db.collection("registrations").where("eventId", "==", tmpEventData.id).get();
      let tmpRegData = [];
      regDataLookup.forEach((doc) => {
        let data = doc.data();
        data.id = doc.id;
        tmpRegData.push(data);
      });
      setRegData(tmpRegData);
      console.log(tmpRegData);
      var updateSessionAvailability = await firebase.functions().httpsCallable("appV2/updateSessionAvailability");
      let sessionAvailability = await updateSessionAvailability({
        sessions: tmpEventData.sessions,
        eventId: tmpEventData.id,
        skipReserved: false,
        skipSessionCheck: true,
        deviceId: GetDeviceId()
      });
      console.log(sessionAvailability);
      let eData = tmpEventData;
      console.log(sessionAvailability.data);
      eData.sessions = sessionAvailability.data.sessions;
      eData.sessionItems.forEach((item, index) => {
        item.itemIndex = index;
        let session = eData.sessions.filter(o => o.itemIndex === index); // this doesn't seem to do anything @Mike
        console.log(session);
        if (session) {
          let days = {};
          session.forEach((s, i) => {
            let d = s.startTime.split(" ")[0];
            let t = s.startTime.split(" ")[1];
            if (!days[d]) days[d] = [];
            let dCheck = days[d].find(o => o.time === t);
            let registered = isSessionRegistered(s.id, tmpRegData);
            if (!dCheck)
              days[d].push({ date: d, time: t, startTime: s.startTime, items: [{ itemIndex: s.itemIndex, available: s.available, reserved: s.reserved, registered: registered, startTime: s.startTime, passcode: s.passcode, id: s.id }] });
            else {
              dCheck.items.push({ itemIndex: s.itemIndex, available: s.available, reserved: s.reserved, registered: registered, startTime: s.startTime, passcode: s.passcode, id: s.id });
            }
          });
          item.sessions = days;
        }
      });
      setEventReportData(eData);
    }
    console.log(tmpEventData);
    console.log(tmpEventData.campaignCode);
    let allcap = [];
    const leadResult = await firebase.functions().httpsCallable("appV2/listLeadActivity")({});
    (leadResult.data || []).filter((row) => row.eventId === id)
      .forEach((row) => addLeadIfForEvent({ id: row.id, data: () => row },
        tmpEventData, allcap));
    //order allcap by createdat
    allcap.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        if (a.createdAt.seconds && b.createdAt.seconds) {

          return b.createdAt.seconds - a.createdAt.seconds;
        } else {
          return b.createdAt - a.createdAt;
        }
      } else if (a.createdAt && !b.createdAt) {
        return -1;
      } else if (!a.createdAt && b.createdAt) {
        return 1;
      } else {
        return 0;
      }
    });
    setData({
      registrations: allcap,
      isFetching: false,
      message: null,
      filtered: null,
      filter: true,
    });

  }
  useEffect(() => {
    loadSessionReport();

    // eslint-disable-next-line react-hooks/exhaustive-deps -- intent: run-once init on mount; loadSessionReport is component-scope
  }, []);
  if (!user.isAuthenticated)
    return <Navigate to="/manage/sign-in" />
  const h1Cls = "text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100";
  const h3Cls = "mt-6 text-lg font-semibold tracking-tight text-zinc-900 dark:text-zinc-100";
  const h4Cls = "mt-6 text-base font-semibold text-zinc-900 dark:text-zinc-100";
  const h5Cls = "mt-2 text-sm font-medium text-zinc-700 dark:text-zinc-300";
  const labelCls = "block text-sm font-medium text-zinc-700 dark:text-zinc-300";
  const inputCls = "mt-2 block w-full rounded-md bg-zinc-50 px-3 py-2 text-sm text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-zinc-900 dark:bg-zinc-800 dark:text-zinc-100 dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white";
  const primaryBtnCls = "inline-flex items-center justify-center rounded-md bg-zinc-900 px-3 py-2 text-sm font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100";
  const primarySmCls = "inline-flex items-center justify-center rounded-md bg-zinc-900 px-2.5 py-1.5 text-xs font-semibold text-zinc-50 shadow-sm hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100";
  const sessionBtnCls = "cursor-pointer ml-2 inline-block rounded px-1.5 text-zinc-700 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-zinc-800";
  const infoAlertCls = "rounded-md bg-blue-500/10 px-3 py-2 text-sm text-blue-700 ring-1 ring-inset ring-blue-500/30 dark:text-blue-300 dark:ring-blue-500/20";
  const tableWrapCls = "mt-4 overflow-x-auto rounded-lg ring-1 ring-zinc-200 dark:ring-zinc-700";
  const tableCls = "min-w-full divide-y divide-zinc-200 bg-zinc-50 dark:divide-zinc-700 dark:bg-zinc-900";
  const theadCls = "bg-zinc-100 dark:bg-zinc-800";
  const tbodyCls = "divide-y divide-zinc-100 dark:divide-zinc-800";
  const thCls = "px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-zinc-500 dark:text-zinc-400";
  const tdCls = "px-4 py-2 text-sm text-zinc-900 dark:text-zinc-100";
  return (
    <div className="mx-auto max-w-7xl">
      <h1 className={h1Cls}>{eventData?.sysname ? eventData?.sysname : eventData?.name} - Session Report</h1>
      {eventData?.allowSessionEditing && addSessionDate && <div className="mt-6 space-y-4">
        <h3 className={h3Cls}>Add Session Date/Time for {addSessionDate.itemName}</h3>
        <div className={infoAlertCls}>
          <p>To add a session date/time, please enter the date and time in the format <b>MM/DD/YYYY HH:mm</b> (e.g., 12/31/2023 14:00 for December 31, 2023, at 2:00 PM).</p>
          <p>Click the <b>+</b> button to add a session date/time.</p>
        </div>
        <div>
          <label htmlFor="startTime" className={labelCls}>Start Date/Time</label>
          <input type="text" className={inputCls} id="startDate" value={addSessionDate?.startTime} onChange={(e) => {
            setAddSessionDate({ ...addSessionDate, startTime: e.target.value });
          }}
            placeholder="YYYY-MM-DD HH:mm (2025-06-25 00:00)" />
        </div>
        <div>
          <label htmlFor="endTime" className={labelCls}>End Date/Time</label>
          <input type="text" className={inputCls} id="endTime" value={addSessionDate?.endTime} placeholder="YYYY-MM-DD HH:mm (2025-06-25 00:00)" onChange={(e) => {
            setAddSessionDate({ ...addSessionDate, endTime: e.target.value });
          }} />
        </div>
        <div className="flex items-center gap-2">
          <input type="checkbox" className="size-4 rounded border-zinc-300 text-zinc-900 focus:ring-zinc-900 dark:border-white/10 dark:bg-zinc-800 dark:focus:ring-white" id="reserved" checked={addSessionDate?.reserved} onChange={(e) => {
            setAddSessionDate({ ...addSessionDate, reserved: e.target.checked });
          }} />
          <label className="text-sm text-zinc-700 dark:text-zinc-300" htmlFor="reserved">Reserved</label>
        </div>
        <div className="flex items-center gap-3">
        <button className={primaryBtnCls} onClick={async () => {
          let tmpEventData = eventData;
          let tmpAddSession = addSessionDate;
          tmpAddSession.id = tmpEventData.sessions.length + 1;
          tmpAddSession.available = true;
          tmpEventData.sessions.push(addSessionDate);
          console.log(tmpEventData);
          var checkEventData = await db.collection("events").doc(tmpEventData?.id).get();
          checkEventData = checkEventData.data();
          checkEventData.sessions = tmpEventData.sessions;
          console.log(checkEventData);
          db.collection("events").doc(tmpEventData?.id).set(checkEventData)
            .then(() => {
              console.log("Session added successfully");
              sessionStorage.setItem('eventData', JSON.stringify(checkEventData));
              loadSessionReport(checkEventData);
              setEventData(checkEventData);

              setAddSessionDate(null);
            }).catch((error) => {
              console.error("Error adding session: ", error);
            });

        }}>Save</button>
        <button className={primaryBtnCls} onClick={() => { setAddSessionDate(null); }}>Cancel</button>
        </div>
      </div>
      }
      {eventReportData?.allowCapacity && eventReportData?.capacityType === "session" && <>
        {eventReportData?.sessionItems?.map((item, index) => {
          return <div key={index} className="mt-8">
            <h4 className={h4Cls}>{item.name}</h4>
            {eventData?.allowSessionEditing && !addSessionDate &&
              <button className={`${primarySmCls} mt-2`} onClick={() => {
                console.log('item', item);
                setAddSessionDate({ itemIndex: item.itemIndex, itemName: item.name }); window.scrollTo({ top: 0, behavior: "smooth" });
              }}>
                Add Date/Time</button>
            }
            {Object.keys(item?.sessions)?.map((s, index) => {
              return <div key={index} className="mt-4">
                <h5 className={h5Cls}>{moment(s).format("dddd MMMM Do YYYY")}</h5>
                <div className={tableWrapCls}>
                <table className={tableCls}>
                  <thead className={theadCls}>
                    <tr>
                      <th className={thCls}>Time</th>
                      <th className={thCls}>Registered</th>
                      <th className={thCls}>Available</th>
                      <th className={thCls}>Reserved</th>
                      <th className={thCls}>Total</th>
                    </tr>
                  </thead>
                  <tbody className={tbodyCls}>
                    {item?.sessions[s]?.map((session, index) => {
                      return (
                        <tr key={index}>
                          <td className={tdCls}>{formatTime(session.time)}</td>
                          <td className={tdCls}>{session.items.filter(o => o.registered || (!o.available && !o.reserved)).length}</td>
                          <td className={tdCls}>{session.items.filter(o => o.available).length}
                            {eventData?.allowSessionEditing && <>
                              <span className={sessionBtnCls} onClick={async () => {
                  

                                var checkEventData = await db.collection("events").doc(eventData?.id).get();
                                checkEventData = checkEventData.data();
                                let endTime = eventData?.sessions.find(o => o.itemIndex === item.itemIndex && o.startTime === s + " " + session.time)?.endTime;
                                checkEventData.sessions.push({ itemIndex: item.itemIndex, startTime: s + " " + session.time, endTime: endTime, available: true, reserved: 0, passcode: "", id: eventData?.sessions.length + 1 });                        
                                db.collection("events").doc(eventData?.id).set(checkEventData)
                                  .then(() => {
                                    sessionStorage.setItem('eventData', JSON.stringify(checkEventData));
                                    loadSessionReport(checkEventData);
                                    setEventData(checkEventData);
                                  }).catch((error) => {
                                    console.error("Error adding session: ", error);
                                  });
                              }}>+</span>
                              {session.items.filter(o => o.available).length > 0 && <>

                                <span>&nbsp;/&nbsp;</span><span className={sessionBtnCls} onClick={async() => {
                                                                  var checkEventData = await db.collection("events").doc(eventData?.id).get();
                                  checkEventData = checkEventData.data();
                                  let tmpSessions = eventData?.sessions.filter(o => o.itemIndex === item.itemIndex && o.startTime === s + " " + session.time && o.available && !o.reserved);
                                  console.log(tmpSessions);
                                  let tmpSession = tmpSessions[tmpSessions.length - 1];
                                  console.log(tmpSession);
                                  //remove from tmpsessions tmpsession id - 1
                                  checkEventData.sessions = checkEventData.sessions.filter(o => o.id !== tmpSession.id);
                                  await db.collection("events").doc(eventData?.id).set(checkEventData);
                                  sessionStorage.setItem('eventData', JSON.stringify(checkEventData));
                                  loadSessionReport(checkEventData);
                                  setEventData(checkEventData);

                                }}>-</span></>
                              }</>}</td>
                          <td className={tdCls}>{session.items.filter(o => o.reserved && !o.registered).length}
                            {eventData?.allowSessionEditing && <>
                              {session.items.filter(o => o.available).length > 0  &&
                                <span className={sessionBtnCls} onClick={async() => {
                                                                  var checkEventData = await db.collection("events").doc(eventData?.id).get();
                                  checkEventData = checkEventData.data();
                                  console.log(checkEventData.sessions);
                                  console.log(item.itemIndex, s, session.time);
                                  let tmpEventData = eventData;
                                  let tmpSessions = tmpEventData?.sessions.filter(o => o.itemIndex === item.itemIndex && o.startTime === s + " " + session.time && o.available && !o.reserved);
                                  console.log(tmpSessions);
                                           
                                  tmpSessions[tmpSessions.length - 1].reserved = 1;
                                  tmpSessions[tmpSessions.length - 1].available = 0;
                                  
                                  checkEventData.sessions = tmpEventData?.sessions;
                                  console.log(checkEventData.sessions);
                                  await db.collection("events").doc(eventData?.id).set(checkEventData);
                                  sessionStorage.setItem('eventData', JSON.stringify(checkEventData));
                                  loadSessionReport(checkEventData);
                                  setEventData(checkEventData);
                                  
                                }}>+</span>
                              }
                              {session.items.filter(o => o.available).length > session.items.filter(o => o.reserved && !o.registered).length && session.items.filter(o => o.reserved && !o.registered).length > 0 &&

                                <span >&nbsp;/&nbsp;</span>
                              }
                              {session.items.filter(o => o.reserved && !o.registered).length > 0 &&
                                <span className={sessionBtnCls} onClick={async() => {
                                                                  var checkEventData = await db.collection("events").doc(eventData?.id).get();
                                  checkEventData = checkEventData.data();
                                  console.log(checkEventData.sessions);
                                  console.log(item.itemIndex, s, session.time);
                                  let tmpEventData = eventData;
                                  let tmpSessions = tmpEventData?.sessions.filter(o => o.itemIndex === item.itemIndex && o.startTime === s + " " + session.time && o.reserved);
                                           
                                  tmpSessions[tmpSessions.length - 1].reserved = 0;
                                  
                                  checkEventData.sessions = tmpEventData?.sessions;
                                  console.log(checkEventData.sessions);
                                  await db.collection("events").doc(eventData?.id).set(checkEventData);
                                  sessionStorage.setItem('eventData', JSON.stringify(checkEventData));
                                  loadSessionReport(checkEventData);
                                  setEventData(checkEventData);
                                  
                                }}>-</span>
                              }
                            </>}
                          </td>
                          <td className={tdCls}>{session.items.length}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                </div>
              </div>
            })}
          </div>
        })}
      </>}

      {eventData?.allowMultiUsePasscodes && eventData?.multiUsePasscodes?.length > 0 && <div className="mt-8">
        <h3 className={h3Cls}>Passcodes</h3>
        <div className={tableWrapCls}>
        <table className={tableCls}>
          <thead className={theadCls}>
            <tr>
              <th className={thCls}>Code</th>
              <th className={thCls}>Total</th>
              <th className={thCls}>Available</th>
              <th className={thCls}>Pending</th>
              <th className={thCls}>Registered</th>
              <th className={thCls}>Checked-In</th>
              <th className={thCls}>Completed</th>
              <th className={thCls}>Waitlist</th>
              <th className={thCls}>Cancelled</th>
            </tr>
          </thead>
          <tbody className={tbodyCls}>
            {eventData?.multiUsePasscodes?.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={tdCls}>{item.description ? item.description : item.passcode}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Total")}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Available")}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Pending")}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Registered", true)}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Checked-In")}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Completed")}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Waitlist")}</td>
                  <td className={tdCls}>{getCount(item.passcode, "Cancelled")}</td>
                </tr>
              )
            })}
            <tr>
              <td className={tdCls}><b>Totals</b></td>
              <td className={tdCls}><b>{getCount(null, "Total")}</b></td>
              <td className={tdCls}><b>{getCount(null, "Available")}</b></td>
              <td className={tdCls}><b>{getCount(null, "Pending")}</b></td>
              <td className={tdCls}><b>{getCount(null, "Registered", true)}</b></td>
              <td className={tdCls}><b>{getCount(null, "Checked-In")}</b></td>
              <td className={tdCls}><b>{getCount(null, "Completed")}</b></td>
              <td className={tdCls}><b>{getCount(null, "Waitlist")}</b></td>
              <td className={tdCls}><b>{getCount(null, "Cancelled")}</b></td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      }
      {eventData?.allowPushToCap && data?.registrations?.length > 0 && <div className="mt-8">
        <h3 className={h3Cls}>Leads Sent</h3>
        <div className={tableWrapCls}>
        <table className={tableCls}>
          <thead className={theadCls}>
            <tr>
              <th className={thCls}>Date Sent</th>
              <th className={thCls}>Data Type</th>
              <th className={thCls}>Campaign Code</th>
              <th className={thCls}>Campaign Description</th>
              <th className={thCls}>Filename</th>
              <th className={thCls}>Records</th>
            </tr>
          </thead>
          <tbody className={tbodyCls}>
            {data?.registrations?.map((r, i) => (
              <tr key={i}>
                <td className={tdCls}>{r.createdDate}</td>
                <td className={tdCls}>{r.dataType}</td>
                <td className={tdCls}>{r.campaignCode}</td>
                <td className={tdCls}>{r.campaignDescription}</td>
                <td className={tdCls}>{r.filename}</td>
                <td className={tdCls}>{r.records}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
      }
    </div>
  );
};
export default Sessions;
